import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Panel from 'react-bootstrap/lib/Panel';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import Avatar from '../../Avatar';

import s from '../ViewMessage.css';
const ToMessage = ({ profileId, picture, displayName, content, createdAt, isPhotoMigrated }) => {

  let date = createdAt != null ? moment(parseInt(createdAt)).format('DD/MM/YYYY') : '';

  return (
    <div>
      <div >
        <div className={cx(s.spaceBottom20)}>
          <div className={cx(s.messageBoxFlex, 'toMessage')}>
            <div className={cx(s.width100, 'radiusColorTwo', 'sendMessageRadius')}>
              <Panel className={cx(s.panelBubble, s.panelText, s.panelBubbleRight, 'ViewBubbleRight', s.panelSendToBubble, s.panelRightMessage, 'viewBubbleRightRTL')}>
                <span>
                  {
                    content && (content.trim()).split("\n").map(function (item, index) {
                      return (
                        <span key={index}>{item}<br /></span>
                      )
                    })
                  }
                </span>
                <div className={cx(s.timeText, s.spaceTop11)}>
                  <span className={cx(s.messageDateText)}>{date}</span>
                </div>
              </Panel>
            </div>
            <div className={s.messageProfilePicSec}>
              <div className={cx(s.profileAvatarSection, 'profileAvatarRight')}>
                <Avatar
                  source={picture}
                  height={48}
                  width={48}
                  title={displayName}
                  className={s.profileAvatar}
                  withLink
                  linkClassName={cx(s.profileAvatarLink, 'profileAvatarLinkRTL')}
                  profileId={profileId}
                  isFromMigration={isPhotoMigrated}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

ToMessage.propTypes = {
  profileId: PropTypes.number.isRequired,
  picture: PropTypes.string,
  displayName: PropTypes.string.isRequired,
  content: PropTypes.string,
  createdAt: PropTypes.string.isRequired
};

ToMessage.defaultProps = {
  createdAt: null
};

export default withStyles(s)(ToMessage);